export default __webpack_public_path__ + "static/media/LogoHeaderPayment.911b1870.svg";